module.exports = __webpack_public_path__ + "static/media/m13cr1023.2be9433d.png";